/* @flow */

import React from 'react';
import useSheet from 'app/jss';

type Props = {
  children: mixed,
  sheet: Object,
};

const defaultProps = {
  children: undefined,
};

function InputPrefix({
  children,
  sheet: { classes },
}: Props) {
  return (
    <div className={classes.prefix}>
      {children}
    </div>
  );
}

InputPrefix.defaultProps = defaultProps;

function applyStyles(theme) {
  return {
    prefix: {
      fontSize: '1.25em',
      fontWeight: theme.fontWeight.demiBold,
      flexBasis: 0,
      flexGrow: 0,
      flexShrink: 0,
      paddingRight: '0.25em',
    },
  };
}

export default useSheet(applyStyles)(InputPrefix);
